<template>
  <div class="jd-filter-box">
    <el-tabs type="border-card" v-if="JSON.stringify(allFilters) !== '{}'" v-model="firstIndex">
      <el-tab-pane :label="item.categoryName" v-for="(item, index) in allFilters" :key="index" :name="index">
        <div class="tabpan-box">
          <div class="column1">
            <el-collapse v-model="secondIndex" accordion @change="changeSecond">
              <el-collapse-item v-for="(item2, index2) in item.sub" :key="index2" :title="item2.categoryName" :name="index2">
                <ul v-if="!item2.tagCode" class="list-li">
                  <li v-for="(item3, index3) in item2.sub" :key="index3" :class="index3 === thirdIndex ? 'active' : ''" @click="chooseSecond(index3)">{{item3.categoryName}}</li>
                </ul>
                <div v-else>
                  <div v-if="item2.child_list">
                    <el-checkbox-group v-model="child_list" @change="changeChildList">
                      <el-checkbox :label="item3.id" v-for="(item3, index3) in item2['child_list']" :key="index3" style="width:100%;"><span class="font12" style="color:rgba(0,0,0,.65);">{{item3.name}}</span></el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div v-else>
                    <el-input type="textarea" placeholder="请输入sku号，多个请用英文逗号隔开" v-model="skuVal" @change="changeSkuVal" style="width:calc(100% - 10px);"></el-input>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
          <div class="column2">
            <ul v-if="JSON.stringify(secondColumn) !== '{}' && secondColumn.isLeafNode === 1" class="list-li">
              <li v-for="(item2, index2) in secondColumn.tag_list" :key="index2" @click="chooseThird(index2)" :class="index2 === fourthIndex ? 'active' : ''"><span>{{item2.tagInstruction}}</span><i class="el-icon-arrow-right"></i></li>
            </ul>
            <ul v-if="JSON.stringify(secondColumn) !== '{}' && secondColumn.isLeafNode === 0" class="list-li">
              <li v-for="(item2, index2) in secondColumn.sub" :key="index2" @click="chooseSecond(index2, 'column3')" :class="index2 === thirdIndex ? 'active' : ''"><span>{{item2.categoryName}}</span><i class="el-icon-arrow-right"></i></li>
            </ul>
          </div>
          <div class="column3">
            <div v-if="JSON.stringify(thirdColumn) !== '{}' && !thirdColumn.sub">
              <div v-if="JSON.stringify(thirdColumn) !== '{}' && thirdColumn['tagTypeView'] === 'enum'" class="enum-box">
                <el-checkbox-group v-model="enumVal" @change="submitEnumVal">
                  <el-checkbox :label="item2.enumCode" v-for="(item2, index2) in thirdColumn['tagEnumList']" :key="index2" style="width:100%;margin-bottom:10px;"><span class="font12" style="color:rgba(0,0,0,.65);">{{item2.enumInstruction}}</span></el-checkbox>
                </el-checkbox-group>
              </div>
              <div v-if="JSON.stringify(thirdColumn) !== '{}' && thirdColumn['tagTypeView'] === 'string'" class="enum-box string-box">
                <div class="range-box-item">
                  <el-input type="textarea" v-model="stringVal" size="small" placeholder="请输入名称，多个请用英文逗号隔开"></el-input>
                </div>
                <div class="range-box-item">
                  <el-button size="small" @click="submitStringVal(false)">确认</el-button>
                </div>
              </div>
            </div>
            <ul v-if="JSON.stringify(thirdColumn) !== '{}' && thirdColumn.isLeafNode === 1" class="list-li">
              <li v-for="(item2, index2) in thirdColumn.tag_list" :key="index2" @click="chooseThird(index2, 'column4')" :class="index2 === fourthIndex ? 'active' : ''"><span>{{item2.tagInstruction}}</span><i class="el-icon-arrow-right"></i></li>
            </ul>
          </div>
          <div class="column4">
            <div v-if="JSON.stringify(fourthColumn) !== '{}' && fourthColumn['tagTypeView'] === 'range'" class="range-box">
              <div v-if="fourthColumn['partitionValue'] === 'ACTIVE'">
                <div class="range-box-item">
                  <el-date-picker
                    style="width:100%;"
                    size="small"
                    v-model="rangeDateVal"
                    :clearable="false"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-date-picker>
                </div>
                <div class="range-box-item" style="text-align:center;">
                  <el-button size="small" style="margin:0 auto;" @click="submitRangeDateVal('column4')">确认</el-button>
                </div>
              </div>
              <div v-if="fourthColumn['partitionValue'] !== 'ACTIVE'">
                <div class="range-box-item">
                  <span>&gt;=</span> <el-input v-model="rangeVal[0]" style="width: 100px;" size="small"></el-input>
                </div>
                <div class="range-box-item">
                  <span>&lt;=</span> <el-input v-model="rangeVal[1]" style="width: 100px;" size="small"></el-input>
                </div>
                <div class="range-box-item">
                  <el-button size="small" style="margin-left:26px;" @click="submitRangeVal('column4')">确认</el-button>
                </div>
                <div class="range-box-item font12 grayae" style="padding-left:26px;">
                  注：<br>
                  购买金额单位：元<br>
                  购买次数单位：个<br>
                  其它单位:次
                </div>
              </div>
            </div>
            <div v-if="JSON.stringify(fourthColumn) !== '{}' && fourthColumn['tagTypeView'] === 'enum'" class="enum-box">
              <el-checkbox-group v-model="enumVal" @change="submitEnumValColumn4">
                <el-checkbox :label="item2.enumCode" v-for="(item2, index2) in fourthColumn['tagEnumList']" :key="index2" style="width:100%;margin-bottom:10px;"><span class="font12" style="color:rgba(0,0,0,.65);">{{item2.enumInstruction}}</span></el-checkbox>
              </el-checkbox-group>
            </div>
            <div v-if="JSON.stringify(fourthColumn) !== '{}' && fourthColumn['tagTypeView'] === 'string'" class="enum-box string-box">
              <div class="range-box-item">
                <el-input v-model="stringVal" size="small"></el-input>
              </div>
              <div class="range-box-item">
                <el-button size="small" @click="submitStringVal('column4')">确认</el-button>
              </div>
              <div class="range-box-item font12 grayae">
                注：<br>
                购买金额单位：元<br>
                购买次数单位：个<br>
                其它单位:次
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  name: 'JdFilters',
  props: [
    'filters',
    'value'
  ],
  data () {
    return {
      allFilters: {},
      firstIndex: '1',
      secondIndex: '1',
      thirdIndex: '',
      fourthIndex: '',
      secondColumn: {},
      thirdColumn: {},
      fourthColumn: {},
      returnVal: {},
      rangeVal: [0, 0],
      rangeDateVal: ['', ''],
      enumVal: [],
      stringVal: '',
      child_list: [],
      skuVal: ''
    }
  },
  watch: {
    'value': function (val) {
      this.returnVal = val
      let curVal = JSON.stringify(this.fourthColumn) === '{}' ? this.thirdColumn : this.fourthColumn
      // console.log('curVal', val)
      if (this.enumVal.length && JSON.stringify(curVal) !== '{}' && JSON.stringify(val) !== '{}') {
        let newEnumVal = []
        val[curVal['tableCode']]['value'].map(item => {
          let skuArr = this.skuVal.split(',')
          if (skuArr.length) {
            skuArr.map((item, index) => {
              skuArr[index] = item.trim()
            })
          }
          let parent = this.child_list.length ? this.child_list : skuArr
          let isThisGroup = curVal['tagEnumList'].find(item2 => {
            if (item.parent) {
              return item2.enumCode === item['value']['values'] && JSON.stringify(item.parent.values.sort()) === JSON.stringify(parent.sort())
            } else {
              return item2.enumCode === item['value']['values']
            }
          })
          if (isThisGroup) {
            newEnumVal.push(item['value']['values'])
          }
        })
        this.enumVal = newEnumVal
      }
      if (JSON.stringify(val) === '{}') {
        this.firstIndex = '1'
        this.secondIndex = '1'
        this.thirdIndex = ''
        this.fourthIndex = ''
        this.secondColumn = {}
        this.thirdColumn = {}
        this.fourthColumn = {}
        this.rangeVal = [0, 0]
        this.rangeDateVal = ['', '']
        this.enumVal = []
        this.child_list = []
        this.skuVal = ''
      }
    },
    'filters': function (val) {
      this.allFilters = JSON.parse(JSON.stringify(val))
    },
    'firstIndex': function (val) {
      this.secondIndex = '1'
      this.thirdIndex = ''
      this.fourthIndex = ''
      this.secondColumn = {}
      this.thirdColumn = {}
      this.fourthColumn = {}
      this.rangeVal = [0, 0]
      this.rangeDateVal = ['', '']
      this.enumVal = []
      this.child_list = []
      this.skuVal = ''
    },
    'secondIndex': function () {
      this.thirdIndex = ''
      this.fourthIndex = ''
      this.thirdColumn = {}
      this.fourthColumn = {}
      this.rangeVal = [0, 0]
      this.rangeDateVal = ['', '']
      this.enumVal = []
      this.stringVal = ''
      this.child_list = []
      this.skuVal = ''
    },
    'thirdIndex': function () {
      this.fourthIndex = ''
      if (this.firstIndex === '1') {
        this.thirdColumn = {}
      }
      this.fourthColumn = {}
      this.rangeVal = [0, 0]
      this.rangeDateVal = ['', '']
      this.enumVal = []
      this.stringVal = ''
    },
    'fourthIndex': function () {
      this.rangeVal = [0, 0]
      this.rangeDateVal = ['', '']
      this.enumVal = []
      this.stringVal = ''
    }
  },
  methods: {
    changeChildList () {
      this.thirdIndex = ''
      this.fourthIndex = ''
      this.thirdColumn = {}
      this.fourthColumn = {}
      this.rangeVal = [0, 0]
      this.rangeDateVal = ['', '']
      this.enumVal = []
      this.stringVal = ''
      this.skuVal = ''
    },
    changeSkuVal () {
      this.thirdIndex = ''
      this.fourthIndex = ''
      this.thirdColumn = {}
      this.fourthColumn = {}
      this.rangeVal = [0, 0]
      this.rangeDateVal = ['', '']
      this.enumVal = []
      this.stringVal = ''
      this.child_list = []
    },
    changeSecond (second) {
      if (second && this.allFilters[this.firstIndex]['sub'][this.secondIndex]['categoryType'] !== 0) {
        this.secondColumn = this.allFilters[this.firstIndex]['sub'][this.secondIndex]
      }
    },
    chooseSecond (third, column3) {
      if (column3) {
        if (this.secondColumn.tagCode) {
          if (this.secondColumn.child_list) {
            if (!this.child_list.length) {
              this.$message.error(`请选择${this.secondColumn.categoryName}！`)
              return false
            }
          } else {
            if (this.skuVal.trim() === '') {
              this.$message.error(`请输入${this.secondColumn.categoryName}！`)
              return false
            }
          }
        }
        this.thirdIndex = third
        this.thirdColumn = this.allFilters[this.firstIndex]['sub'][this.secondIndex]['sub'][third]
      } else {
        this.thirdIndex = third
        this.secondColumn = this.allFilters[this.firstIndex]['sub'][this.secondIndex]['sub'][third]
      }
    },
    chooseThird (fourth, column4) {
      this.fourthIndex = fourth
      if (column4) {
        this.fourthColumn = this.allFilters[this.firstIndex]['sub'][this.secondIndex]['sub'][this.thirdIndex]['tag_list'][fourth]
        if (this.fourthColumn.tagTypeView === 'enum' && this.returnVal[this.fourthColumn.tableCode]) {
          if (this.secondColumn.tagCode) {
            if (this.secondColumn.child_list) {
              let oldEnumVal = []
              this.returnVal[this.fourthColumn.tableCode]['value'].map(item => {
                if (JSON.stringify(this.child_list.sort()) == JSON.stringify(item['parent']['values'].sort())) {
                  oldEnumVal.push(item['value']['values'])
                }
              })
              this.$nextTick(() => {
                this.enumVal = oldEnumVal
              })
            } else {
              let oldEnumVal = []
              this.returnVal[this.fourthColumn.tableCode]['value'].map(item => {
                let skuArr = this.skuVal.split(',')
                if (skuArr.length) {
                  skuArr.map((item, index) => {
                    skuArr[index] = item.trim()
                  })
                }
                if (JSON.stringify(skuArr.sort()) == JSON.stringify(item['parent']['values'].sort())) {
                  oldEnumVal.push(item['value']['values'])
                }
              })
              this.$nextTick(() => {
                this.enumVal = oldEnumVal
              })
            }
          }
        }
      } else {
        this.thirdColumn = this.allFilters[this.firstIndex]['sub'][this.secondIndex]['sub'][this.thirdIndex]['tag_list'][fourth]
        if (this.thirdColumn.tagTypeView === 'enum' && this.returnVal[this.thirdColumn.tableCode]) {
          let oldEnumVal = []
          this.returnVal[this.thirdColumn.tableCode]['value'].map(item => {
            if (item.title === `${this.allFilters[this.firstIndex]['sub'][this.secondIndex].categoryName}-${this.secondColumn.categoryName}-${this.thirdColumn.tagInstruction}`) {
              oldEnumVal.push(item['value']['values'])
            }
          })
          this.$nextTick(() => {
            this.enumVal = oldEnumVal
          })
        }
      }
    },
    submitRangeDateVal (column4) {
      if (this.rangeDateVal[0] === '' || this.rangeDateVal[1] === '') {
        this.$message.error('请选择日期！')
        return false
      }
      if (column4) {
        let parent = {}
        let desc = ''
        if (this.secondColumn.tagCode) {
          parent['tagCode'] = this.secondColumn.tagCode
          if (this.secondColumn.child_list) {
            if (!this.child_list.length) {
              this.$message.error(`请选择${this.secondColumn.categoryName}！`)
              return false
            }
            parent['values'] = this.child_list
            this.secondColumn.child_list.map(item => {
              this.child_list.map(item2 => {
                if (item.id === item2) {
                  desc += item.name + '/'
                }
              })
            })
            desc = desc.substr(0,desc.length-1)
          } else {
            if (!this.skuVal.trim()) {
              this.$message.error(`请输入${this.secondColumn.categoryName}！`)
              return false
            }
            console.log(this.skuVal)
            let skuArr = this.skuVal.split(',')
            if (skuArr.length) {
              skuArr.map((item, index) => {
                skuArr[index] = item.trim()
              })
            }
            parent['values'] = skuArr
            skuArr.map(item => {
              desc += item + '/'
            })
            desc = desc.substr(0,desc.length-1)
          }
        }
        if (!this.returnVal[this.fourthColumn['tableCode']]) {
          this.returnVal[this.fourthColumn['tableCode']] = {}
        }
        if (!this.returnVal[this.fourthColumn['tableCode']]['value']) {
          this.returnVal[this.fourthColumn['tableCode']]['value'] = []
        }
        let obj = {
          title: `${this.secondColumn.categoryName}-${this.thirdColumn.categoryName}-${this.fourthColumn.tagInstruction}`,
          desc: desc,
          group: this.fourthColumn['tableCode'],
          value: {
            tagCode: this.fourthColumn.tagCode,
            defaultTagTypeView: 'dateRange',
            tagTypeView: this.fourthColumn.tagTypeView,
            tagTypeView: this.fourthColumn.tagTypeView,
            values: this.rangeDateVal
          }
        }
        if (JSON.stringify(parent) !== '{}') {
          obj['parent'] = parent
        }
        for (let key in this.returnVal[this.fourthColumn['tableCode']]['value']) {
          let item = this.returnVal[this.fourthColumn['tableCode']]['value'][key]
          if (item.desc === desc && JSON.stringify(item.parent.values.sort()) === JSON.stringify(parent.values.sort()) && JSON.stringify(this.rangeDateVal.sort()) === JSON.stringify(Array.isArray(item.value.values) ? item.value.values.sort() : [item.value.values])) {
            this.$message.error('已存在相同标签！')
            return false
          }
        }
        this.returnVal[this.fourthColumn['tableCode']]['value'].push(obj)
      }
      this.submitRerutnVal()
    },
    submitRangeVal (column4) {
      if (this.rangeVal[0] === '' || this.rangeVal[1] === '' || !this.util.isNumber(this.rangeVal[0]) || !this.util.isNumber(this.rangeVal[1]) || Number(this.rangeVal[0]) < 1 || Number(this.rangeVal[1]) < 1) {
        this.$message.error('请输入数字！')
        return false
      }
      if (column4) {
        let parent = {}
        let desc = ''
        if (this.secondColumn.tagCode) {
          parent['tagCode'] = this.secondColumn.tagCode
          if (this.secondColumn.child_list) {
            if (!this.child_list.length) {
              this.$message.error(`请选择${this.secondColumn.categoryName}！`)
              return false
            }
            parent['values'] = this.child_list
            this.secondColumn.child_list.map(item => {
              this.child_list.map(item2 => {
                if (item.id === item2) {
                  desc += item.name+ '/'
                }
              })
            })
            desc = desc.substr(0,desc.length-1)
          } else {
            if (!this.skuVal.trim()) {
              this.$message.error(`请输入${this.secondColumn.categoryName}！`)
              return false
            }
            let skuArr = this.skuVal.split(',')
            if (skuArr.length) {
              skuArr.map((item, index) => {
                skuArr[index] = item.trim()
              })
            }
            parent['values'] = skuArr
            skuArr.map(item => {
              desc += item + '/'
            })
            desc = desc.substr(0,desc.length-1)
          }
        }
        if (!this.returnVal[this.fourthColumn['tableCode']]) {
          this.returnVal[this.fourthColumn['tableCode']] = {}
        }
        if (!this.returnVal[this.fourthColumn['tableCode']]['value']) {
          this.returnVal[this.fourthColumn['tableCode']]['value'] = []
        }
        let title = `${this.secondColumn.categoryName}-${this.thirdColumn.categoryName}-${this.fourthColumn.tagInstruction}`
        let obj = {
          title: title,
          desc: desc,
          group: this.fourthColumn['tableCode'],
          value: {
            tagCode: this.fourthColumn.tagCode,
            tagTypeView: this.fourthColumn.tagTypeView,
            tagTypeView: this.fourthColumn.tagTypeView,
            values: this.rangeVal
          }
        }
        if (JSON.stringify(parent) !== '{}') {
          obj['parent'] = parent
        }
        for (let key in this.returnVal[this.fourthColumn['tableCode']]['value']) {
          let item = this.returnVal[this.fourthColumn['tableCode']]['value'][key]
          if (item.desc === desc && item.title === title && JSON.stringify(item.parent.values.sort()) === JSON.stringify(parent.values.sort()) && JSON.stringify(this.rangeVal.sort()) === JSON.stringify(item.value.values.sort())) {
            // console.log(item)
            // console.log('desc', desc)
            // console.log('parent.values', parent.values)
            // console.log('this.rangeVal', this.rangeVal)
            this.$message.error('已存在相同标签！')
            return false
          }
        }
        this.returnVal[this.fourthColumn['tableCode']]['value'].push(obj)
      }
      this.submitRerutnVal()
    },
    submitStringVal (column4) {
      if (column4) {
        if (this.stringVal.trim() === '' || !this.util.isNumber(this.stringVal)) {
          this.$message.error('请输入的数字！')
          return false
        }
        let parent = {}
        let desc = ''
        if (this.secondColumn.tagCode) {
          parent['tagCode'] = this.secondColumn.tagCode
          if (this.secondColumn.child_list) {
            if (!this.child_list.length) {
              this.$message.error(`请选择${this.secondColumn.categoryName}！`)
              return false
            }
            parent['values'] = this.child_list
            this.secondColumn.child_list.map(item => {
              this.child_list.map(item2 => {
                if (item.id === item2) {
                  desc += item.name+ '/'
                }
              })
            })
            desc = desc.substr(0,desc.length-1)
          } else {
            if (!this.skuVal.trim()) {
              this.$message.error(`请输入${this.secondColumn.categoryName}！`)
              return false
            }
            let skuArr = this.skuVal.split(',')
            if (skuArr.length) {
              skuArr.map((item, index) => {
                skuArr[index] = item.trim()
              })
            }
            parent['values'] = skuArr
            skuArr.map(item => {
              desc += item + '/'
            })
            desc = desc.substr(0,desc.length-1)
          }
        }
        if (!this.returnVal[this.fourthColumn['tableCode']]) {
          this.returnVal[this.fourthColumn['tableCode']] = {}
        }
        if (!this.returnVal[this.fourthColumn['tableCode']]['value']) {
          this.returnVal[this.fourthColumn['tableCode']]['value'] = []
        }
        let obj = {
          title: `${this.secondColumn.categoryName}-${this.thirdColumn.categoryName}-${this.fourthColumn.tagInstruction}`,
          desc: desc,
          group: this.fourthColumn['tableCode'],
          value: {
            tagCode: this.fourthColumn.tagCode,
            tagTypeView: this.fourthColumn.tagTypeView,
            tagTypeView: this.fourthColumn.tagTypeView,
            values: this.stringVal.trim()
          }
        }
        if (JSON.stringify(parent) !== '{}') {
          obj['parent'] = parent
        }
        for (let key in this.returnVal[this.fourthColumn['tableCode']]['value']) {
          let item = this.returnVal[this.fourthColumn['tableCode']]['value'][key]
          if (item.desc === desc && JSON.stringify(item.parent.values.sort()) === JSON.stringify(parent.values.sort()) && this.stringVal.trim() === item.value.values) {
            this.$message.error('已存在相同标签！')
            return false
          }
        }
        this.returnVal[this.fourthColumn['tableCode']]['value'].push(obj)
      } else {
        if (this.stringVal.trim() === '') {
          this.$message.error('请输入内容！')
          return false
        }
        let parent = {}
        let desc = ''
        let title = ''
        console.log(this.secondColumn)
        console.log(this.thirdColumn)
        if (this.secondColumn.tagCode) {
          parent['tagCode'] = this.secondColumn.tagCode
          if (this.secondColumn.child_list) {
            if (!this.child_list.length) {
              this.$message.error(`请选择${this.secondColumn.categoryName}！`)
              return false
            }
            parent['values'] = this.child_list
            this.secondColumn.child_list.map(item => {
              this.child_list.map(item2 => {
                if (item.id === item2) {
                  desc += item.name+ '/'
                }
              })
            })
            desc = desc.substr(0,desc.length-1)
          } else {
            if (!this.skuVal.trim()) {
              this.$message.error(`请输入${this.secondColumn.categoryName}！`)
              return false
            }
            let skuArr = this.skuVal.split(',')
            if (skuArr.length) {
              skuArr.map((item, index) => {
                skuArr[index] = item.trim()
              })
            }
            parent['values'] = skuArr
            skuArr.map(item => {
              desc += item + '/'
            })
            desc = desc.substr(0,desc.length-1)
          }
        }
        if (!this.returnVal[this.thirdColumn['tableCode']]) {
          this.returnVal[this.thirdColumn['tableCode']] = {}
        }
        if (!this.returnVal[this.thirdColumn['tableCode']]['value']) {
          this.returnVal[this.thirdColumn['tableCode']]['value'] = []
        }
        title = `${this.allFilters[this.firstIndex]['sub'][this.secondIndex].categoryName}-${this.secondColumn.categoryName}-${this.thirdColumn.tagInstruction}`
        var values = this.stringVal.split(',')
        if (values.length) {
          values.map((item, index) => {
            values[index] = item.trim()
          })
        }
        let obj = {
          title: title,
          desc: desc,
          group: this.thirdColumn['tableCode'],
          value: {
            tagCode: this.thirdColumn.tagCode,
            tagTypeView: this.thirdColumn.tagTypeView,
            tagTypeView: this.thirdColumn.tagTypeView,
            values: values
          }
        }
        if (JSON.stringify(parent) !== '{}') {
          obj['parent'] = parent
        }
        for (let key in this.returnVal[this.thirdColumn['tableCode']]['value']) {
          let item = this.returnVal[this.thirdColumn['tableCode']]['value'][key]
          if (item.desc === desc && item.title === title && JSON.stringify(this.stringVal.split(',').sort()) === JSON.stringify(item.value.values.sort())) {
            this.$message.error('已存在相同标签！')
            return false
          }
        }
        this.returnVal[this.thirdColumn['tableCode']]['value'].push(obj)
      }
      this.submitRerutnVal()
    },
    submitEnumVal (val) {
      if (val.length) {
        let parent = {}
        let title = ''
        let desc = ''
        let name = []
        if (this.secondColumn.tagCode) {
          parent['tagCode'] = this.secondColumn.tagCode
          if (this.secondColumn.child_list) {
            if (!this.child_list.length) {
              this.$message.error(`请选择${this.secondColumn.categoryName}！`)
              return false
            }
            parent['values'] = this.child_list
            this.secondColumn.child_list.map(item => {
              this.child_list.map(item2 => {
                if (item.id === item2) {
                  desc += item.name+ '/'
                }
              })
            })
            desc = desc.substr(0,desc.length-1)
          } else {
            if (!this.skuVal.trim()) {
              this.$message.error(`请输入${this.secondColumn.categoryName}！`)
              return false
            }
            let skuArr = this.skuVal.split(',')
            if (skuArr.length) {
              skuArr.map((item, index) => {
                skuArr[index] = item.trim()
              })
            }
            parent['values'] = skuArr
            skuArr.map(item => {
              desc += item + '/'
            })
            desc = desc.substr(0,desc.length-1)
          }
        }
        if (!this.returnVal[this.thirdColumn['tableCode']]) {
          this.returnVal[this.thirdColumn['tableCode']] = {}
        }
        this.enumVal.map(item => {
          this.thirdColumn.tagEnumList.map(item2 => {
            if (item === item2.enumCode) {
              name.push(item2.enumInstruction)
            }
          })
        })
        if (!this.returnVal[this.thirdColumn['tableCode']]['value']) {
          this.returnVal[this.thirdColumn['tableCode']]['value'] = []
        }
        title = `${this.allFilters[this.firstIndex]['sub'][this.secondIndex].categoryName}-${this.secondColumn.categoryName}-${this.thirdColumn.tagInstruction}`
        let a = []
        this.returnVal[this.thirdColumn['tableCode']]['value'].map((item, index) => {
          if (item.title === title) {
            a.unshift(index)
          }
        })
        a.map(item => {
          this.returnVal[this.thirdColumn['tableCode']]['value'].splice(item, 1)
        })
        if (!this.enumVal.length) return false
        this.enumVal.map((item, index) => {
          let obj = {
            title: title,
            desc: desc,
            group: this.thirdColumn['tableCode'],
            name: name[index],
            value: {
              tagCode: this.thirdColumn.tagCode,
              tagTypeView: this.thirdColumn.tagTypeView,
              tagTypeView: this.thirdColumn.tagTypeView,
              values: item
            }
          }
          if (JSON.stringify(parent) !== '{}') {
            obj['parent'] = parent
          }
          this.returnVal[this.thirdColumn['tableCode']]['value'].push(obj)
        })
      } else {
        this.returnVal[this.thirdColumn['tableCode']]['value'] = []
      }
      this.submitRerutnVal()
    },
    submitEnumValColumn4 (val) {
      if (val.length) {
        let parent = {}
        let title = ''
        let desc = ''
        let name = []
        if (this.secondColumn.tagCode) {
          parent['tagCode'] = this.secondColumn.tagCode
          if (this.secondColumn.child_list) {
            if (!this.child_list.length) {
              this.$message.error(`请选择${this.secondColumn.categoryName}！`)
              return false
            }
            parent['values'] = this.child_list
            this.secondColumn.child_list.map(item => {
              this.child_list.map(item2 => {
                if (item.id === item2) {
                  desc += item.name+ '/'
                }
              })
            })
            desc = desc.substr(0,desc.length-1)
          } else {
            if (!this.skuVal.trim()) {
              this.$message.error(`请输入${this.secondColumn.categoryName}！`)
              return false
            }
            let skuArr = this.skuVal.split(',')
            if (skuArr.length) {
              skuArr.map((item, index) => {
                skuArr[index] = item.trim()
              })
            }
            parent['values'] = skuArr
            skuArr.map(item => {
              desc += item + '/'
            })
            desc = desc.substr(0,desc.length-1)
          }
        }
        if (!this.returnVal[this.fourthColumn['tableCode']]) {
          this.returnVal[this.fourthColumn['tableCode']] = {}
        }
        this.enumVal.map(item => {
          this.fourthColumn.tagEnumList.map(item2 => {
            if (item === item2.enumCode) {
              name.push(item2.enumInstruction)
            }
          })
        })
        if (!this.returnVal[this.fourthColumn['tableCode']]['value']) {
          this.returnVal[this.fourthColumn['tableCode']]['value'] = []
        }
        title = `${this.secondColumn.categoryName}-${this.thirdColumn.categoryName}-${this.fourthColumn.tagInstruction}`
        let a = []
        this.returnVal[this.fourthColumn['tableCode']]['value'].map((item, index) => {
          if (JSON.stringify(item.parent.values.sort()) == JSON.stringify(parent.values.sort()) && item.title === title) {
            a.unshift(index)
          }
        })
        a.map(item => {
          this.returnVal[this.fourthColumn['tableCode']]['value'].splice(item, 1)
        })
        if (!this.enumVal.length) return false
        this.enumVal.map((item, index) => {
          let obj = {
            title: title,
            desc: desc,
            group: this.fourthColumn['tableCode'],
            name: name[index],
            value: {
              tagCode: this.fourthColumn.tagCode,
              tagTypeView: this.fourthColumn.tagTypeView,
              tagTypeView: this.fourthColumn.tagTypeView,
              values: item
            }
          }
          if (JSON.stringify(parent) !== '{}') {
            obj['parent'] = parent
          }
          this.returnVal[this.fourthColumn['tableCode']]['value'].push(obj)
        })
      } else {
        this.returnVal[this.fourthColumn['tableCode']]['value'] = []
      }
      this.submitRerutnVal()
    },
    submitRerutnVal () {
      this.$emit('getChooseVal', this.returnVal)
    }
  },
  mounted () {
  },
  created () {
    this.allFilters = this.filters
  }
}
</script>

<style scoped>
.jd-filter-box {
  font-size: 12px;
  color: rgba(0,0,0,.65);
}
.tabpan-box {
  width: 100%;
  height: auto;
  overflow: hidden;
  display: flex;
}
.tabpan-box>div {
  border-right: 1px solid #eee;
  flex: 1;
}
.range-box {
  padding: 0 20px;
}
.range-box-item {
  margin-bottom: 10px;
}
.range-box-item span {
  display: inline-block;
  width: 22px;
}
.list-li li {
  width: 100%;
  height: 30px;
  line-height: 30px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  padding: 0 20px;
  cursor :pointer;
}
.list-li li span {
  display: inline-block;
  height: 30px;
  width: calc(100% - 30px);
  float: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.list-li li i {
  float: right;
  line-height: 30px;
}
.enum-box {
  padding: 0 20px;
}
.active {
  background: #f5f6fa;
  color: #4d77f4;
}
</style>
